/**
 * @file: 查询货架添加对象
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';

/**
 * 1. 找货架
 * 2. 找画布
 */
function shelfAddInfo(cubeData: FreeObjMap, insertTarget: CubeId, extendParams: FreeObjMap = {}): InsertInfo {
    let sketchpad: CubeId = CubeTree.findSketchpad();

    if (CubeTree.isShelf(insertTarget)) {
        let targetIndex: number = CubeTree.getCubeIndexInParent(insertTarget);

        return {
            insertData: cubeData,
            parentId: sketchpad,
            index: targetIndex + 1,
            targetId: insertTarget
        };
    }

    let shelfCount: number = CubeTree.getShelfCount();

    return {
        insertData: cubeData,
        parentId: sketchpad,
        index: shelfCount,
        targetId: sketchpad
    };
}

export {
    shelfAddInfo
};
